import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import scrollToComponent from "react-scroll-to-component";
import styles from "./styles.less";

class ScrollToButton extends React.Component {
  scrollTo = () => {
    const { targetRef, onScrollEnd, align } = this.props;
    const cb = scrollToComponent(targetRef, {
      align
    });
    cb.on("end", onScrollEnd);
  };

  render() {
    const { hidden, label, bounce, pointdirection } = this.props;

    return (
      <div
        className={cx(styles.scrollToButtonWrapper, {
          [styles.hidden]: hidden
        })}
      >
        <div className={styles.label}>{label}</div>
        <div
          className={cx(
            styles.btn,
            { [styles.bounce]: bounce },
            styles[pointdirection]
          )}
          onClick={this.scrollTo}
          onKeyDown={this.scrollTo}
          role="button"
          tabIndex="0"
        />
      </div>
    );
  }
}

ScrollToButton.defaultProps = {
  bounce: true,
  hidden: false,
  label: "Click Me",
  align: "top",
  pointdirection: "down",
  onScrollEnd: () => {}
};

ScrollToButton.propTypes = {
  hidden: PropTypes.bool,
  bounce: PropTypes.bool,
  label: PropTypes.string,
  pointdirection: PropTypes.oneOf(["up", "down"]),
  align: PropTypes.oneOf(["top", "middle", "bottom"]),
  targetRef: PropTypes.object,
  onScrollEnd: PropTypes.func
};

export default ScrollToButton;



// WEBPACK FOOTER //
// ./src/components/common/ScrollToButton/ScrollToButton.js